//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "GiftCardForm",
  inject: [
    'giftCardData'
  ],
  watch: {
    'giftCardData.resetForm'(val) {
      if(val) {
        this.giftCardData.resetForm = false;
        this.$refs?.form?.reset();
      }
    }
  },
  computed: {
    notesHeight() {
      const notesHeight = document?.querySelector('.note-validate')?.offsetHeight;
      return this.giftCardData.giftcard_note && notesHeight ? notesHeight : 0;
    }
  }
}
